import { JwtPayload } from "interfaces/jwtpayload";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { Container, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { PUBLIC_ROUTE } from "../../routes/publicRoutes";
import { login } from "../../store/slices/authSlice";
import { Navbar } from "./components/Navbar/Navbar";
import "./header.css";
import { RootState } from "store/store";
import { PRIVATE_ROUTE } from "routes/privateRoutes";

export const Header = () => {
  const { isLogged } = useSelector((state: RootState) => state.authData);
  const logoHeader = "/assets/img/logo-header.svg";
  const location = useLocation();

  return (
    <header className="container-fluid fixed-top">
      <Container fluid className="header-container">
        {location.pathname.includes(PRIVATE_ROUTE.API) ? (
          <>
            <div className="header-logo-container">
              <Link to={PRIVATE_ROUTE.INICIO} className="text-dark">
                <Image
                  src={logoHeader}
                  alt="Logo Vamos Buenos Aires"
                  className="header-logo"
                />{" "}
                Documentación API's
              </Link>
            </div>
          </>
        ) : isLogged ? (
          <>
            <div className="header-logo-container">
              <Link to={PRIVATE_ROUTE.INICIO} className="text-dark">
                <Image
                  src={logoHeader}
                  alt="Logo Vamos Buenos Aires"
                  className="header-logo"
                />{" "}
                Entidad Planes de estudio
              </Link>
            </div>
            <Navbar></Navbar>
          </>
        ) : (
          <>
            <Image
              src={logoHeader}
              alt="Logo Vamos Buenos Aires"
              className="header-logo"
            />
            <h1 className="header-title">Entidad Planes de estudio</h1>
          </>
        )}
      </Container>
    </header>
  );
};
